import React, { useEffect } from 'react';
import { getDashboardRole } from '../../utils/accountType';
import { useSelector } from 'react-redux';
import './dashboard.css';
import DasgboardIndividual from './DasgboardIndividual';
import DasgboardNonprofit from './DasgboardNonprofit';
import DashboardSettingScreen from './dashboardSetting/DashboardSettingScreen';

const Dashboard: React.FC = (props: any) => {
  const logged = useSelector((state: any) => getDashboardRole(state.signin.type));
  const { match } = props;
  const section = match?.params?.section; // Get the section from URL (e.g., 'settings')

  useEffect(()=>{})

  // If section is 'settings', show the settings screen regardless of user type
  if (section === 'settings') {
    return <DashboardSettingScreen />;
  }

  return (
    <>
      {logged === 'individual' &&
        <DasgboardIndividual />
      }
      {logged === 'nonprofit' &&
        <DasgboardNonprofit />
      }

    </>
  );
};

export default Dashboard;
